// 合约地址与 ABI（仅暴露用户/查询方法，不含 DEV 紧急函数）

export const FACTORY_ADDRESS = process.env.REACT_APP_FACTORY_ADDRESS || "";

// 用户在 flap.sh launch 完代币后填入；未填时前端进 demo 模式
export const VAULT_ADDRESS = process.env.REACT_APP_VAULT_ADDRESS || "";
export const TOKEN_ADDRESS = process.env.REACT_APP_TOKEN_ADDRESS || "";

export const VAULT_ABI = [
  // ---- view ----
  { type: "function", name: "poolBalance", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "lotteryEnabled", stateMutability: "view", inputs: [], outputs: [{ type: "bool" }] },
  { type: "function", name: "holdingThreshold", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "cooldown", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "minHoldTime", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "taxToken", stateMutability: "view", inputs: [], outputs: [{ type: "address" }] },
  {
    type: "function", name: "getPrizeConfig", stateMutability: "view", inputs: [],
    outputs: [
      { name: "prob1Bps", type: "uint16" },
      { name: "prob2Bps", type: "uint16" },
      { name: "prob3Bps", type: "uint16" },
      { name: "noPrizeBps", type: "uint16" },
      { name: "prize1", type: "uint256" },
      { name: "prize2", type: "uint256" },
      { name: "prize3", type: "uint256" },
    ],
  },
  {
    type: "function", name: "getVaultStats", stateMutability: "view", inputs: [],
    outputs: [
      { name: "_poolBalance", type: "uint256" },
      { name: "_totalTaxReceived", type: "uint256" },
      { name: "_totalPrizesPaid", type: "uint256" },
      { name: "_totalVrfFunded", type: "uint256" },
      { name: "_totalPortalFee", type: "uint256" },
      { name: "_totalDraws", type: "uint256" },
      { name: "_tier1Wins", type: "uint64" },
      { name: "_tier2Wins", type: "uint64" },
      { name: "_tier3Wins", type: "uint64" },
      { name: "_noPrizeCount", type: "uint64" },
    ],
  },
  {
    type: "function", name: "getLastWin", stateMutability: "view", inputs: [],
    outputs: [
      { name: "winner", type: "address" },
      { name: "amount", type: "uint256" },
      { name: "tier", type: "uint8" },
      { name: "at", type: "uint64" },
    ],
  },
  {
    type: "function", name: "getUserStats", stateMutability: "view", inputs: [{ name: "user", type: "address" }],
    outputs: [
      { name: "eligible", type: "bool" },
      { name: "tokenBalance", type: "uint256" },
      { name: "lastDrawAt", type: "uint256" },
      { name: "nextDrawAt", type: "uint256" },
      { name: "drawCount", type: "uint256" },
      { name: "prizeWon", type: "uint256" },
    ],
  },
  {
    type: "function", name: "getCheckInStatus", stateMutability: "view", inputs: [{ name: "user", type: "address" }],
    outputs: [
      { name: "checkedIn", type: "bool" },
      { name: "balanceAt", type: "uint256" },
      { name: "at", type: "uint256" },
      { name: "secsLeft", type: "uint256" },
      { name: "canDraw", type: "bool" },
    ],
  },
  // ---- write ----
  { type: "function", name: "checkIn", stateMutability: "nonpayable", inputs: [], outputs: [] },
  { type: "function", name: "draw", stateMutability: "nonpayable", inputs: [], outputs: [] },
  // ---- events ----
  { type: "event", name: "CheckedIn", inputs: [
    { indexed: true, name: "user", type: "address" },
    { indexed: false, name: "balanceAt", type: "uint128" },
    { indexed: false, name: "at", type: "uint64" },
  ]},
  { type: "event", name: "DrawRequested", inputs: [
    { indexed: true, name: "user", type: "address" },
    { indexed: true, name: "requestId", type: "uint256" },
  ]},
  { type: "event", name: "DrawCompleted", inputs: [
    { indexed: true, name: "user", type: "address" },
    { indexed: true, name: "requestId", type: "uint256" },
    { indexed: false, name: "tier", type: "uint8" },
    { indexed: false, name: "amount", type: "uint256" },
  ]},
];

export const ERC20_ABI = [
  { type: "function", name: "balanceOf", stateMutability: "view", inputs: [{ type: "address" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "symbol", stateMutability: "view", inputs: [], outputs: [{ type: "string" }] },
  { type: "function", name: "decimals", stateMutability: "view", inputs: [], outputs: [{ type: "uint8" }] },
];

// PancakeSwap 买入链接
export const buyLink = (token) =>
  `https://pancakeswap.finance/swap?outputCurrency=${token}&inputCurrency=BNB`;
